import type { PartnerConfig } from "@/content/partners/types"

export const EXPLORA_EBIKE_FESTIVAL_SLUG = "explora-ebike-festival"

export const EXPLORA_EBIKE_FESTIVAL_EVENT_URL =
  "https://www.sympla.com.br/evento/explora-ebike-festival/3536427"

/** Fim do dia 24/10/2026 America/Sao_Paulo (UTC−3). */
export const EXPLORA_EBIKE_FESTIVAL_ACTIVE_UNTIL = "2026-10-25T02:59:59.999Z"

export const exploraEbikeFestivalPartnerConfig: PartnerConfig = {
  slug: EXPLORA_EBIKE_FESTIVAL_SLUG,
  name: "Explora Ebike Festival",
  fullName: "Explora Ebike Festival — Sabará",
  logoPath: "/partners/explora-ebike-festival/logo.jpg",
  benefitMode: "none",
  isActive: true,
  activeUntil: EXPLORA_EBIKE_FESTIVAL_ACTIVE_UNTIL,
  partnershipMention: "Parceria de evento · Explora Ebike Festival",
  metadata: {
    kind: "event_partnership_coupon",
    website: EXPLORA_EBIKE_FESTIVAL_EVENT_URL,
    event_platform: "sympla",
    coupon_amount_brl: 100,
  },
}

export const exploraEbikeFestivalLpContent = {
  slug: EXPLORA_EBIKE_FESTIVAL_SLUG,
  eventName: "Explora Ebike Festival",
  logoPath: exploraEbikeFestivalPartnerConfig.logoPath,
  datesLabel: "24 de outubro de 2026",
  locationLabel: "Villa Capão, Sabará/MG",
  platformName: "Sympla",
  eventUrl: EXPLORA_EBIKE_FESTIVAL_EVENT_URL,
  heroKicker: "Parceria Explora Ebike Festival",
  heroSubtitle:
    "Energia solar por assinatura, sem obra e sem investimento inicial. Quem concluir a adesão por este link recebe um cupom de R$ 100 na inscrição.",
  partnershipTitle: "R$ 100 na inscrição",
  partnershipIntro:
    "Depois que você concluir a adesão por este link, enviamos o cupom para você usar na inscrição no Sympla.",
  benefitHeadline: "O que esta parceria inclui",
  benefits: [
    {
      title: "Cupom de R$ 100 na inscrição",
      text: "Vale na inscrição do Explora Ebike Festival, no Sympla.",
    },
    {
      title: "Enviamos depois da adesão",
      text: "Você recebe o cupom depois de concluir a adesão por este link.",
    },
    {
      title: "Desconto da Astra na conta de luz",
      text: "O plano segue a regra usual da assinatura, conforme o consumo da sua conta Cemig.",
    },
  ],
  faqs: [
    {
      question: "Quem recebe o cupom de R$ 100?",
      answer:
        "Quem concluir a adesão Astra por este link, com os termos assinados e o contato confirmado.",
    },
    {
      question: "Quando eu recebo o código?",
      answer: "Depois da adesão concluída. Enviamos o cupom para você.",
    },
    {
      question: "Como uso o cupom no Sympla?",
      answer:
        "Quando receber o código, abra a inscrição do Explora Ebike Festival no Sympla e informe o cupom no checkout do evento.",
    },
    {
      question: "Esse cupom vale em outro evento?",
      answer: "Ele vale na inscrição do Explora Ebike Festival.",
    },
    {
      question: "Isso aumenta o desconto na conta de luz?",
      answer:
        "O desconto da assinatura Astra continua o do seu plano. O R$ 100 entra na inscrição.",
    },
    {
      question: "A Astra instala painéis no meu telhado?",
      answer:
        "Não. É energia solar por assinatura: a geração vem de usinas da Astra e você recebe desconto na conta de luz, sem obra e sem investimento inicial.",
    },
  ],
  ctaLabel: "Fazer minha adesão",
  ctaFinalHeadline: "Faça sua adesão por este link",
  ctaFinalSubtitle:
    "Sem obra e sem investimento inicial. Depois da adesão concluída, enviamos o cupom de R$ 100 da inscrição.",
  disclaimer:
    "Cupom de R$ 100 na inscrição do Explora Ebike Festival, no Sympla. Enviamos o código depois da adesão concluída por este link.",
  metaTitle: "Explora Ebike Festival · R$ 100 na inscrição | Astra Energia",
  metaDescription:
    "Faça sua adesão à Astra Energia pelo link do Explora Ebike Festival e receba um cupom de R$ 100 na inscrição no Sympla. Sem obra e sem investimento inicial.",
} as const
